module.exports = __webpack_public_path__ + "img/browse-vehicles-background-ford.4802755f.gif";